<template>
    <div class="new-list-group-item new-list-group-item-add" v-if="canCreate">

        <div class="row g-3">
            <div class="col-5">

                <v-select
                    label="name"
                    :options="subscriptions"
                    :reduce="subscription => subscription.id"
                    v-model="draft.subscription_id"
                />

                <!--  v-if="draft.subscription.external === 1" -->
                <select class="form-select mt-2" v-model="draft.min_allowed_external_treatments" v-if="draft.subscription_id && subscriptions.find(s => s.id === draft.subscription_id).external">
                    <option :value="null">Min antal beh. per dag</option>
                    <option value="6">6 behandlingar/3 timmar</option>
                    <option value="8">8 behandlingar/4 timmar</option>
                </select>

            </div>
            <div class="col-2">
                <datepicker-new
                    input-class="form-control form-control-sm"
                    placeholder="Välj"
                    :use-utc="false"
                    :language="former.datepicker.locale"
                    :monday-first="true"
                    :disabled-dates="disabledDates"
                    :format="formerDateFormat"
                    v-model="draft.starts_at"
                    />
            </div>
            <div class="col-2">
                <input type="number" class="form-control" placeholder="Startavg." v-model="draft.start_fee" />
            </div>
            <div class="col-2"><span>Nytt</span></div>
            <div class="col-3">
                <select class="form-select" v-model="draft.admin_id">
                    <option :value="null">Välj...</option>
                    <option :key="admin.id" :value="admin.id" v-for="admin in admins">
                        {{ admin.name }}
                    </option>
                </select>
            </div>
            <div class="col-2">
                <span v-if="draft.subscription_id && draft.starts_at && draft.admin_id && company.organization_number">
                    <a :href="'/companies/' + company.id + '/contracts/' + draft.id+'/downloadTemplate'" target="_blank">
                        <span class="fa fa-arrow-down" style="margin-right: 4px;"></span>Hämta
                    </a>
                </span>
                <span v-if="!company.organization_number">
                    <i>Org.nr saknas</i>
                </span>
            </div>
            <div class="col-4">
                <div class="row g-1" v-if="draft.subscription_id && draft.starts_at && draft.admin_id && company.organization_number">
                    <div class="col-24" v-if="!draft.upload_new_name">
                        <input class="form-control form-control-sm" type="file" id="formFile" @change="upload">
                    </div>
                    <div class="col-24" v-if="draft.upload_new_name">
                        {{ draft.upload_original_name }} <button class="btn btn-danger btn-sm d-inline-block ms-2" style="padding: 0 0.5rem;" @click="draft.upload_new_name = null">X</button>
                    </div>
                </div>
            </div>
            <div class="col-4 d-flex justify-content-end" v-if="draft.upload_new_name">
                <button class="btn btn-primary btn-sm" @click="activate()">Aktivera avtal</button>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import vSelect from 'vue-select'

import patcher from '../../../../shared/mixins/patcher'
import { activeContract, pendingContract } from '../../../../shared/methods/contract-filter'

export default {

    mixins: [
        patcher
    ],

    components: {
        vSelect
    },

    props: {
        company: {
            required: true
        },
        draftContract: {
            required: true
        },
        admins: {
            required: true
        },
        contracts: {
            required: true
        },
        subscriptions: {
            required: true
        }
    },

    data () {
        return {
            draft: this.draftContract
        }
    },

    computed: {
        canCreate () {
            if (this.contracts.length === 0) {
                return true
            }

            if (this.pendingContract(this.contracts)) {
                return false
            }

            if (this.activeContract(this.contracts) && !this.activeContract(this.contracts).ends_at) {
                return false
            }

            return true
        },

        disabledDates () {
            let last_contract_ends_at = null
            if (this.activeContract(this.contracts) && this.activeContract(this.contracts).ends_at) {
                last_contract_ends_at = this.activeContract(this.contracts).ends_at
            }

            let first_price_period_at = null
            if (this.draftContract.subscription_id) {
                const subscription = this.subscriptions.find(s => s.id === this.draftContract.subscription_id)
                if (subscription && subscription.price_periods[0]) {
                    first_price_period_at = subscription.price_periods[0].starts_at
                }
            }

            return {
                customPredictor (date) {
                    if (!first_price_period_at || moment(date).isBefore(first_price_period_at)) {
                        return true
                    }

                    if (last_contract_ends_at && moment(date).isSameOrBefore(last_contract_ends_at)) {
                        return true
                    }

                    if (date.getDate() !== 1 && date.getDate() !== 15) {
                        return true
                    }
                }
            }
        }
    },

    watch: {

        draftContract: {
            deep: true,
            handler () {
                this.draft = this.draftContract
            }
        },

        draft: {
            deep: true,
            handler () {
                console.log('draft updated, time to save')

                this.save()
            }
        }
    },

    methods: {

        upload (event) {
            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)

            axios.post(
                '/companies/' + this.company.id + '/contracts/' + this.draft.id + '/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.draft = response.data.contract
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
        },

        activate () {
            this.draft.activated_at = moment().toISOString()
            bus.$emit(
                'notify',
                'Abonnemanget har aktiverats'
            )
        },

        save () {
            axios.patch(
                '/companies/' + this.company.id + '/contracts/' + this.draft.id,
                this.draft
            )
                .then(response => {
                    console.log('save response')
                    console.log(response.data)

                    if (response.data.contract.activated_at) {
                        this.$emit('refresh')
                    }
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
        },

        activeContract: activeContract,

        pendingContract: pendingContract

    }

}
</script>
